/**
 * @generated SignedSource<<ba986a75568029abb96c3b5151ac5bce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapWithSidebarLayout_map",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapBase_map"
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "6e8b351b4a029e751660fe7eb97b0e02";

module.exports = node;
